export const ESTATE_PARENT_SINGULAR = "Campo";
export const ESTATE_PARENT_PLURAL = "Campos";
export const ESTATE_SINGULAR = "Bodega";
export const ESTATE_PLURAL = "Bodegas";
